<template>
    <v-menu v-model="menu" :close-on-content-click="false"
            transition="scale-transition" offset-y
            max-width="290px" min-width="290px">
        <template v-slot:activator="{ on }">
            <v-text-field
                    :value="computedDateFormatted"
                    :label="label" filled hide-details prepend-inner-icon="event"
                    readonly v-on="on"/>
        </template>
        <v-date-picker :value="value" @input="syncInput" no-title locale="nb"/>
    </v-menu>
</template>

<script>
    import dayjs from "dayjs";

    export default {
        props: {
            label: {
                type: String,
                default: () => 'Dato'
            },
            value: {
                type: String,
                default: ''
            }
        },


        data() {
            return {
                menu: false
            }
        },

        computed: {
            computedDateFormatted() {
                let date = dayjs(this.value);
                if (!date.isValid()) return;

                return dayjs(this.value).format('DD.MM.YYYY');
            },
        },

        methods: {
            syncInput(value) {
                this.$emit('input', value);
                this.menu = false;
            }
        },
    }
</script>